import {
  BUDGET_MODULE_PAGE_LINKS,
  SELECTED_BUDGET_MODULE_PAGE_KEY,
  SELECTED_BUDGET_MODULE_YEAR_KEY,
  USER_PROGRESS_KEY,
} from "../constants/budgetModule";

export const getBudgetFlowProgress = () => {
  try {
    return (
      JSON.parse(window.localStorage.getItem(USER_PROGRESS_KEY) ?? "null") ?? {
        budgetPlannerProgress: false,
        budgetPlannerCompleted: false,
        reImportBudgetPlannerProgress: false,
      }
    );
  } catch (_error) {
    return {
      budgetPlannerProgress: false,
      budgetPlannerCompleted: false,
      reImportBudgetPlannerProgress: false,
    };
  }
};

export const saveBudgetFlowProgress = (value) => {
  window.localStorage.setItem(USER_PROGRESS_KEY, JSON.stringify(value));
};

export const setBudgetFlowStarted = () => {
  saveBudgetFlowProgress({
    ...getBudgetFlowProgress(),
    budgetPlannerProgress: true,
    budgetPlannerCompleted: false,
    reImportBudgetPlannerProgress: false,
  });
};

export const setBudgetFlowCompleted = () => {
  saveBudgetFlowProgress({
    ...getBudgetFlowProgress(),
    budgetPlannerProgress: false,
    budgetPlannerCompleted: true,
    reImportBudgetPlannerProgress: false,
  });
};

export const resetBudgetFlow = () => {
  saveBudgetFlowProgress({
    ...getBudgetFlowProgress(),
    budgetPlannerProgress: false,
    budgetPlannerCompleted: false,
    reImportBudgetPlannerProgress: false,
  });
};

export const getSelectedBudgetModulePage = () => {
  const savedPage =
    window.localStorage.getItem(SELECTED_BUDGET_MODULE_PAGE_KEY) ?? "";

  return BUDGET_MODULE_PAGE_LINKS.some((item) => item.path === savedPage)
    ? savedPage
    : "";
};

export const saveSelectedBudgetModulePage = (path) => {
  window.localStorage.setItem(SELECTED_BUDGET_MODULE_PAGE_KEY, path);
};

export const clearSelectedBudgetModulePage = () => {
  window.localStorage.removeItem(SELECTED_BUDGET_MODULE_PAGE_KEY);
};

export const getSelectedBudgetModuleYear = () => {
  return window.localStorage.getItem(SELECTED_BUDGET_MODULE_YEAR_KEY) ?? "";
};

export const saveSelectedBudgetModuleYear = (year) => {
  if (year) {
    window.localStorage.setItem(SELECTED_BUDGET_MODULE_YEAR_KEY, year);
  } else {
    window.localStorage.removeItem(SELECTED_BUDGET_MODULE_YEAR_KEY);
  }
};
